module.exports = (__webpack_require__(8896))(3966);